// extracted by mini-css-extract-plugin
export default {"wrapper":"KeyTypeBadge_wrapper__XXrsf"};